import { useEffect } from "react";
import "./App.css";
import Projects from "./pages/projects/Projects";
import DialogOutlet from "./components/DialogOutlet";
import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";

const App = ({ isLoggedIn }) => {
    const clearSelectedProject = (): void => {};

    useEffect(() => {
        if (!isLoggedIn) return;
    }, [isLoggedIn]);

    if (isLoggedIn) {
        return (
            <Provider store={store}>
                <Projects clearSelectedProject={clearSelectedProject} />
                <DialogOutlet></DialogOutlet>
            </Provider>
        );
    } else {
        return <div>Not logged in</div>;
    }
};

export default App;
